<section
  *ngIf="resAcctSumDetails && resAcctSumContent && isDelta"
  [class]="
    getCurrentClassName(
      resAcctSumDetails.membershipLevel,
      resAcctSumDetails.is360Tier,
      resAcctSumDetails.millionMiler
    ) +
    '--' +
    resAcctSumDetails.membershipLevel
  "
  [ngClass]="
    getClassNames(
      resAcctSumDetails.membershipLevel,
      resAcctSumDetails.is360Tier,
      resAcctSumDetails.millionMiler
    )
  "
>
  <div class="row no-gutters pt-0 welcome-section">
    <div class="welcome-message w-75">{{ greetingMessage }}</div>
    <span class="sr-only">{{ greetingMessage }}</span>
  </div>
  <div class="row no-gutters miles-section">
    <div class="col-sm-12 col-md-12 col-xl-12 col-lg-12 skymiles-details">
      <span class="miles-no">
        #{{ resAcctSumDetails?.smNumber }}
        <span class="milesNo-separator">
          &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
        </span>
        {{ resAcctSumDetails?.smBalance | number }}
        {{ resAcctSumContent?.availableMilesLabel }}
      </span>
    </div>
    <span class="sr-only">
      #{{ resAcctSumDetails?.smNumber }}
      {{ resAcctSumDetails?.smBalance | number }}
      {{ resAcctSumContent?.availableMilesLabel }}
    </span>
  </div>
  <ng-container
    *ngIf="
      showStaticTracker && isDelta;
      then showStaticTracker;
      else oldContent
    "
  ></ng-container>
  <ng-template #showStaticTracker>
    <div class="valued-traveller mt-3">
      {{ staticTrackerAemContent?.currentStatusLabel }}
      {{ getMemberDesc }}
    </div>
    <span class="sr-only">
      {{ staticTrackerAemContent?.currentStatusLabel }}
      {{ getMemberDesc }}
    </span>
  </ng-template>
  <ng-template #oldContent>
    <div class="valued-traveller mt-3">
      {{ resAcctSumContent?.thankYouMessageMember }}
      {{ getMemberDesc }}
    </div>
    <span class="sr-only">
      {{ resAcctSumContent?.thankYouMessageMember }}
      {{ getMemberDesc }}
    </span>
  </ng-template>
  <span
    *ngIf="resAcctSumDetails?.skyPriority"
    aria-label="Sky Priority"
    class="btn sky-priorityBtn"
  >
    Sky Priority
  </span>
</section>
<section
  *ngIf="resAcctSumDetails && resAcctSumContent && !isDelta"
  [ngClass]="getClassNames(resAcctSumDetails.membershipLevel)"
>
  <div class="va-account-block">
    <div
      [ngClass]="getTierStyles(resAcctSumDetails.membershipLevel)"
      class="row no-gutters va-welcome-section"
    >
      <p class="welcome-message">
        {{ greetingMessage }} {{ resAcctSumDetails?.firstName }}
      </p>
    </div>
    <div class="row no-gutters va-miles-section">
      <div class="col-sm-12 col-md-12 col-xl-12 col-lg-12 skymiles-details">
        <span class="miles-no">
          {{ resAcctSumDetails?.smNumber }}
          <span class="milesNo-separator">
            &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
          </span>
          <span class="miles-count">
            {{ resAcctSumDetails?.smBalance | number }}
          </span>
          {{ resAcctSumContent?.availableMilesLabel }}
        </span>
      </div>
    </div>
  </div>
</section>
